// OtpModal.jsx
import React, { useState, useEffect } from "react";

const OtpModal = ({ type, value, onClose, onVerify }) => {
  const [otp, setOtp] = useState("");
  const [timer, setTimer] = useState(60);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    let interval = null;
    if (timer > 0) {
      interval = setInterval(() => {
        setTimer((prev) => prev - 1);
      }, 1000);
    } else {
      setCanResend(true);
    }
    return () => clearInterval(interval);
  }, [timer]);

  const handleVerify = () => {
    if (otp.length === 4) {
      onVerify(type, otp, value, onClose);
    }
  };

  return (
    <div className="fixed inset-0 z-50 bg-black bg-opacity-50 flex items-center justify-center">
      <div className="bg-white rounded-lg shadow-lg p-6 w-full max-w-sm">
        <h3 className="text-lg font-semibold mb-4">
          Enter 4-digit OTP sent to your {type}
        </h3>
        <input
          type="text"
          maxLength={4}
          value={otp}
          onChange={(e) => setOtp(e.target.value.replace(/\D/, ""))}
          className="w-full border border-gray-300 rounded px-4 py-2 text-center text-lg tracking-widest mb-4"
        />
        <div className="flex justify-between items-center text-sm text-gray-600 mb-4">
          <span>
            {canResend ? (
              <button
                className="text-blue-600 hover:underline"
                onClick={() => {
                  setTimer(60);
                  setCanResend(false);
                  // Ideally call resend OTP handler here
                }}
              >
                Resend OTP
              </button>
            ) : (
              `Resend in ${timer}s`
            )}
          </span>
          <button onClick={onClose} className="text-red-500 hover:underline">
            Cancel
          </button>
        </div>
        <button
          onClick={handleVerify}
          disabled={otp.length !== 4}
          className="w-full bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
        >
          Verify
        </button>
      </div>
    </div>
  );
};

export default OtpModal;
